export default __webpack_public_path__ + "static/media/package-a-small.1dbfedb3.jpg";